import { createSlice } from '@reduxjs/toolkit';
import { ICustomerAppState } from '../../types/store';

const initialState: ICustomerAppState = {
  content: [],
  page: {
    size: 0,
    number: 0,
    totalElements: 0,
    totalPages: 0,
  },
  start_time: null,
  end_time: null,
  enabled: null,
};

const customerAppSlice = createSlice({
  name: 'customerAppSlice',
  initialState,
  reducers: {
    setDisplayedProducts: (state, action) => {
      state.content = action.payload.content;
      state.page = action.payload.page;
      state.end_time = action.payload.end_time ?? null;
      state.start_time = action.payload.start_time ?? null;
      state.enabled = action.payload.enabled ?? null;
    },
    clearProducts: (state) => {
      state.content = [];
      state.page = initialState.page;
      state.start_time = null;
      state.end_time = null;
      state.enabled = null;
    },
  },
});

export const { setDisplayedProducts, clearProducts } = customerAppSlice.actions;

export default customerAppSlice.reducer;
